import { useCallback, useEffect, useState } from 'react';

import {
  type FTemplateSectionFragment,
  useUpdateTemplateSectionsOrderMutation,
} from '@dashboard/generated/wp/platform';
import { arrayMove } from '@dnd-kit/sortable';

export function useMutateableSections(sections: FTemplateSectionFragment[]) {
  const [reorderSections] = useUpdateTemplateSectionsOrderMutation();
  const [orderedSections, setOrderedSections] = useState(() => {
    return [...sections].sort((a, b) => a.orderIndex - b.orderIndex);
  });

  useEffect(() => {
    const orderedSections = [...sections].sort((a, b) => a.orderIndex - b.orderIndex);
    setOrderedSections(orderedSections);
  }, [sections]);

  const reorder = useCallback(
    async (activeId: string, overId: string) => {
      const sourceIndex = orderedSections.findIndex((s) => s.id === activeId);
      const targetIndex = orderedSections.findIndex((s) => s.id === overId);
      if (sourceIndex === -1 || targetIndex === -1) {
        throw new Error('Invalid section indexes');
      }
      const tempSections = arrayMove(orderedSections, sourceIndex, targetIndex);
      setOrderedSections(tempSections);
      await reorderSections({ variables: { ids: tempSections.map((s) => s.id) } });
    },
    [reorderSections, orderedSections, setOrderedSections]
  );

  return [orderedSections, reorder] as const;
}
